// extracted by mini-css-extract-plugin
export default {"ladningbg":"Thankyou_ladningbg__Z9haN","box":"Thankyou_box__pJp-0"};